import React from 'react';
import { Outlet } from 'react-router-dom';

function Public() {
  return (
    <>
      <div className="public-content">
        <Outlet />
      </div>
    </>
  );
}

export default Public;
